// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"0e3eee0b","664":"0e3eee0b","783":"0e3eee0b"}[chunkId] + ".chunk.css";
};